import { Component, Input } from '@angular/core';

@Component({
  selector: 'text-truncate',
  template: `
    <span>
      <p *ngIf="truncationApplies() && !displayAll">
        {{ truncatedText }}
        <button class="btn-link truncate-toggle-text -show-more" (click)="toggleShow()">
          {{ moreLabel ? moreLabel : 'home.patient_message.details' | translate }}
        </button>
      </p>
      <p *ngIf="!truncationApplies() || displayAll">
        {{ text }}
        <button *ngIf="truncationApplies()" class="btn-link truncate-toggle-text -show-less" (click)="toggleShow()">
          {{ lessLabel ? lessLabel : 'home.patient_message.show_less' | translate }}
        </button>
      </p>
    </span>
  `,
})

export class TextTruncateComponent {
  @Input() text: string;
  @Input() charsThreshold: number;
  @Input() moreLabel: string;
  @Input() lessLabel: string;

  public displayAll = false;

  toggleShow() {
    this.displayAll = !this.displayAll;
  }

  // Remove 3 more characters to compensate for ...
  get truncatedText(): string {
    return `${ this.text.substr(0, this.charsThreshold - 3) }...`;
  }

  truncationApplies() {
    return this.text.length > this.charsThreshold;
  }
};



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/shared/text-truncate/text-truncate.component.ts